import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: () => import('@/pages/Index')
        },
        {
            path: '/404',
            name: 'NotFound',
            component: () => import('@/pages/404')
        },
        {
            path: '*',
            redirect: {
                path: '/404'
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js